import Link from "next/link";
import Image from "next/image";

export const CANONICAL_LOGO = "/brand/vowent-mark-color.png";

export function LogoMark({
  className = "",
  size = 30,
}: {
  className?: string;
  size?: number;
}) {
  return <Image className={className} src={CANONICAL_LOGO} alt="" width={size} height={size} aria-hidden="true" priority />;
}

export function Wordmark({
  className = "",
  onDark = false,
}: {
  className?: string;
  onDark?: boolean;
}) {
  return (
    <Link
      href="/"
      aria-label="Vowent — home"
      className={`brand-wordmark group inline-flex items-center gap-2 ${onDark ? "brand-wordmark--dark" : ""} ${className}`}
    >
      <LogoMark
        size={28}
        className="brand-mark"
      />
      <span className={`font-display text-[1.35rem] font-semibold leading-none tracking-tight ${onDark ? "text-white" : "text-ink"}`}>
        Vowent
      </span>
    </Link>
  );
}
